const variables = {
    primaryColor: "rgb(31,34,125)",
    secondaryColor: "rgb(255,207,0)",
    secondaryColorDark: "rgb(255, 168, 0)"
};

module.exports = variables;
